export default {"src":"/_next/static/media/illustration-fillers.051c8da0.svg","height":47,"width":47};